<div class="col-xl provider-monthly-wrap">
    <div class="monthly-header">
        <div>
            <h4 class="provider-list-title">Pagos a Proveedores</h4>
            <p class="provider-list-subtitle">Gestión mensual de pagos a proveedores.</p>
        </div>
        <div class="monthly-header-actions">
            <div class="monthly-month-picker">
                <button type="button" class="monthly-month-trigger" (click)="toggleMonthPicker()">
                    <i class="ti ti-calendar"></i>
                    <span>{{ periodLabel }}</span>
                    <i class="ti ti-chevron-down monthly-month-picker-chevron" [class.rotated]="monthPickerOpen"></i>
                </button>

                <div class="monthly-month-dropdown" *ngIf="monthPickerOpen">
                    <div class="monthly-month-dropdown-year">
                        <button type="button" (click)="pickerPrevYear()"><i class="ti ti-chevron-left"></i></button>
                        <span>{{ pickerYear }}</span>
                        <button type="button" (click)="pickerNextYear()"><i class="ti ti-chevron-right"></i></button>
                    </div>
                    <div class="monthly-month-dropdown-grid">
                        <button type="button" *ngFor="let m of monthShortNames; let i = index"
                            class="monthly-month-dropdown-item" [class.active]="isPickerMonthSelected(i)"
                            (click)="selectPickerMonth(i)">{{ m }}</button>
                    </div>
                </div>
            </div>
            <button type="button" class="btn-monthly-export" (click)="exportCsv()">
                <i class="ti ti-download"></i>
                Exportar
            </button>
        </div>
    </div>

    <div class="monthly-kpis" *ngIf="summary">
        <div class="monthly-kpi-card">
            <div>
                <span class="monthly-kpi-label">Total a pagar este mes</span>
                <div class="monthly-kpi-value">{{ formatMoney(summary.total.amount) }}</div>
                <span class="monthly-kpi-sub">{{ summary.total.count }} pagos</span>
            </div>
            <span class="monthly-kpi-icon monthly-kpi-icon--total"><i class="ti ti-folder"></i></span>
        </div>
        <div class="monthly-kpi-card">
            <div>
                <span class="monthly-kpi-label">Pendientes</span>
                <div class="monthly-kpi-value monthly-kpi-value--pending">{{ formatMoney(summary.pending.amount) }}</div>
                <span class="monthly-kpi-sub">{{ summary.pending.count }} pagos</span>
            </div>
            <span class="monthly-kpi-icon monthly-kpi-icon--pending"><i class="ti ti-clock"></i></span>
        </div>
        <div class="monthly-kpi-card">
            <div>
                <span class="monthly-kpi-label">Autorizados</span>
                <div class="monthly-kpi-value monthly-kpi-value--authorized">{{ formatMoney(summary.authorized.amount) }}</div>
                <span class="monthly-kpi-sub">{{ summary.authorized.count }} pagos</span>
            </div>
            <span class="monthly-kpi-icon monthly-kpi-icon--authorized"><i class="ti ti-shield-check"></i></span>
        </div>
        <div class="monthly-kpi-card">
            <div>
                <span class="monthly-kpi-label">Pagados</span>
                <div class="monthly-kpi-value monthly-kpi-value--paid">{{ formatMoney(summary.paid.amount) }}</div>
                <span class="monthly-kpi-sub">{{ summary.paid.count }} pagos</span>
            </div>
            <span class="monthly-kpi-icon monthly-kpi-icon--paid"><i class="ti ti-credit-card"></i></span>
        </div>
    </div>

    <div class="monthly-toolbar">
        <div class="monthly-filters">
            <button type="button" class="monthly-filter" [class.active]="statusFilter === 'all'" (click)="setStatusFilter('all')">
                Todos <span class="monthly-filter-count">{{ summary?.total?.count ?? 0 }}</span>
            </button>
            <button type="button" class="monthly-filter monthly-filter--pending" [class.active]="statusFilter === 'pending'" (click)="setStatusFilter('pending')">
                <span class="monthly-dot monthly-dot--pending"></span>
                Pendientes <span class="monthly-filter-count">{{ summary?.pending?.count ?? 0 }}</span>
            </button>
            <button type="button" class="monthly-filter monthly-filter--authorized" [class.active]="statusFilter === 'authorized'" (click)="setStatusFilter('authorized')">
                <span class="monthly-dot monthly-dot--authorized"></span>
                Autorizados <span class="monthly-filter-count">{{ summary?.authorized?.count ?? 0 }}</span>
            </button>
            <button type="button" class="monthly-filter monthly-filter--paid" [class.active]="statusFilter === 'paid'" (click)="setStatusFilter('paid')">
                <span class="monthly-dot monthly-dot--paid"></span>
                Pagados <span class="monthly-filter-count">{{ summary?.paid?.count ?? 0 }}</span>
            </button>
        </div>
        <div class="monthly-search">
            <i class="ti ti-search"></i>
            <input type="text" placeholder="Buscar proveedor" [(ngModel)]="search" (ngModelChange)="onSearchChange()">
        </div>
    </div>

    <div class="monthly-grid" *ngIf="cards.length > 0">
        <div class="monthly-card" *ngFor="let card of cards">
            <div class="monthly-card-top">
                <div class="monthly-card-identity">
                    <div class="monthly-card-avatar" [style.background]="card.avatarBg" [style.color]="card.avatarColor">{{ card.avatarInitial }}</div>
                    <div>
                        <p class="monthly-card-name">{{ card.provider_name }}</p>
                        <p class="monthly-card-concept">{{ card.concept }}</p>
                    </div>
                </div>
                <span [class]="statusBadgeClass(card.status)">{{ statusLabel(card.status) }}</span>
            </div>

            <p class="monthly-card-period">{{ periodLabel }}</p>
            <div class="monthly-card-amount">
                <span>{{ formatMoney(card.amount) }}</span>
                <i class="ti ti-file-text"></i>
            </div>
            <p class="monthly-card-due">Fecha límite de pago: {{ formatDate(card.due_date) }}</p>

            <div class="monthly-steps">
                <div class="monthly-steps-connectors">
                    <div class="monthly-step-cell monthly-step-cell--grow">
                        <span class="monthly-step-dot" [class.is-done]="stepState(card, 1) === 'done'" [class.is-current]="stepState(card, 1) === 'current'">
                            <i class="ti ti-check" *ngIf="stepState(card, 1) === 'done'"></i>
                            <i class="ti ti-circle" *ngIf="stepState(card, 1) !== 'done'"></i>
                        </span>
                        <div class="monthly-step-line" [class.is-done]="stepState(card, 1) === 'done'" [class.is-current]="stepState(card, 1) === 'current'"></div>
                    </div>
                    <div class="monthly-step-cell monthly-step-cell--grow">
                        <span class="monthly-step-dot" [class.is-done]="stepState(card, 2) === 'done'" [class.is-current]="stepState(card, 2) === 'current'">
                            <i class="ti ti-check" *ngIf="stepState(card, 2) === 'done'"></i>
                            <i class="ti ti-circle" *ngIf="stepState(card, 2) !== 'done'"></i>
                        </span>
                        <div class="monthly-step-line" [class.is-done]="stepState(card, 2) === 'done'" [class.is-current]="stepState(card, 2) === 'current'"></div>
                    </div>
                    <div class="monthly-step-cell monthly-step-cell--fixed">
                        <span class="monthly-step-dot" [class.is-done]="stepState(card, 3) === 'done'" [class.is-current]="stepState(card, 3) === 'current'">
                            <i class="ti ti-check" *ngIf="stepState(card, 3) === 'done'"></i>
                            <i class="ti ti-circle" *ngIf="stepState(card, 3) !== 'done'"></i>
                        </span>
                    </div>
                </div>
                <div class="monthly-steps-labels">
                    <div class="monthly-step-label-cell monthly-step-cell--grow">
                        <span class="monthly-step-label" [innerHTML]="twoLineLabel('Factura Recibida')"></span>
                    </div>
                    <div class="monthly-step-label-cell monthly-step-cell--grow">
                        <span class="monthly-step-label" [innerHTML]="twoLineLabel(step2Label(card))"></span>
                    </div>
                    <div class="monthly-step-label-cell monthly-step-cell--fixed">
                        <span class="monthly-step-label" [innerHTML]="twoLineLabel(step3Label(card))"></span>
                    </div>
                </div>
            </div>

            <button type="button" class="monthly-card-detail" (click)="openDetail(card)">
                Ver detalle <i class="ti ti-chevron-right"></i>
            </button>
        </div>
    </div>

    <p class="monthly-empty" *ngIf="cards.length === 0">No hay pagos registrados para {{ periodLabel }}.</p>

    <div class="monthly-load-more" *ngIf="hasMore">
        <button type="button" (click)="loadMore()" [disabled]="loadingMore">
            <i class="ti ti-chevron-down"></i>
            {{ loadingMore ? 'Cargando…' : 'Cargar más proveedores' }}
        </button>
    </div>
</div>

<div class="monthly-detail-backdrop" *ngIf="detailPayment || detailLoading" (click)="closeDetail()"></div>
<div class="monthly-detail-panel" *ngIf="detailPayment || detailLoading">
    <ng-container *ngIf="detailLoading">
        <p class="text-muted text-center py-5">Cargando…</p>
    </ng-container>

    <ng-container *ngIf="detailPayment as p">
        <div class="monthly-detail-header">
            <h4>{{ p.provider_name }}</h4>
            <button type="button" class="monthly-detail-close" (click)="closeDetail()"><i class="ti ti-x"></i></button>
        </div>

        <div class="monthly-detail-status-row">
            <span [class]="statusBadgeClass(p.status)">{{ statusLabel(p.status) }}</span>
            <span class="monthly-detail-period">{{ periodLabel }}</span>
        </div>

        <div class="monthly-detail-amount">{{ formatMoney(p.amount) }}</div>
        <p class="monthly-detail-concept">{{ p.concept }}</p>

        <h6 class="monthly-detail-subtitle">Línea de tiempo del pago</h6>

        <div class="monthly-timeline">
            <div class="monthly-timeline-step">
                <div class="monthly-timeline-rail">
                    <span class="monthly-timeline-icon" [class.is-done]="stepState(p, 1) === 'done'" [class.is-current]="stepState(p, 1) === 'current'">
                        <i class="ti ti-check" *ngIf="stepState(p, 1) === 'done'"></i>
                        <i class="ti ti-alert-circle" *ngIf="stepState(p, 1) === 'current'"></i>
                    </span>
                    <div class="monthly-timeline-line" [class.is-done]="stepState(p, 1) === 'done'" [class.is-current]="stepState(p, 1) === 'current'"></div>
                </div>
                <div class="monthly-timeline-body">
                    <p class="monthly-timeline-title">Factura recibida</p>
                    <p class="monthly-timeline-sub">{{ p.has_invoice ? 'Factura cargada' : 'Factura pendiente de carga' }}</p>

                    <div class="monthly-invoice-file" *ngIf="p.has_invoice">
                        <a [href]="p.invoice_url" target="_blank" class="monthly-invoice-file-name">
                            <i class="ti ti-file-type-pdf"></i>
                            <span>{{ invoiceFileName(p) }}</span>
                        </a>
                        <button type="button" class="monthly-invoice-delete" [disabled]="actionLoading" (click)="deleteInvoiceFile()" title="Quitar factura">
                            <i class="ti ti-trash"></i>
                        </button>
                    </div>

                    <div class="monthly-invoice-fields">
                        <div class="monthly-invoice-field">
                            <label>N° de factura</label>
                            <input type="text" class="form-control" placeholder="Ingresar" [(ngModel)]="invoiceNumberDraft" (blur)="saveInvoiceDetails()">
                        </div>
                        <div class="monthly-invoice-field">
                            <label>Fecha de facturación</label>
                            <input type="date" class="form-control" [(ngModel)]="invoiceDateDraft" (change)="saveInvoiceDetails()">
                        </div>
                    </div>

                    <label class="monthly-timeline-link monthly-invoice-upload monthly-detail-btn" *ngIf="!uploadingInvoice && !p.has_invoice">
                        Adjuntar factura
                        <input type="file" accept=".pdf,.jpg,.jpeg,.png" (change)="onInvoiceSelected($event)" hidden>
                    </label>
                    <span class="monthly-timeline-link" *ngIf="uploadingInvoice">Subiendo…</span>
                </div>
            </div>

            <div class="monthly-timeline-step">
                <div class="monthly-timeline-rail">
                    <span class="monthly-timeline-icon" [class.is-done]="stepState(p, 2) === 'done'" [class.is-current]="stepState(p, 2) === 'current'">
                        <i class="ti ti-check" *ngIf="stepState(p, 2) === 'done'"></i>
                        <i class="ti ti-alert-circle" *ngIf="stepState(p, 2) === 'current'"></i>
                        <span *ngIf="stepState(p, 2) === 'pending'">2</span>
                    </span>
                    <div class="monthly-timeline-line" [class.is-done]="stepState(p, 2) === 'done'" [class.is-current]="stepState(p, 2) === 'current'"></div>
                </div>
                <div class="monthly-timeline-body">
                    <p class="monthly-timeline-title">Autorización</p>
                    <p class="monthly-timeline-sub" *ngIf="p.status < 2">Pendiente de autorización</p>
                    <p class="monthly-timeline-sub" *ngIf="p.status >= 2">Autorizado el {{ formatDateTime(p.authorized_at) }}</p>
                    <label class="monthly-timeline-checkbox" *ngIf="p.status === 1 && p.has_invoice">
                        <input type="checkbox" [disabled]="actionLoading" (change)="markAuthorized()">
                        Marcar como autorizado
                    </label>
                    <p class="monthly-timeline-sub" *ngIf="p.status === 1 && !p.has_invoice">Adjunta la factura para poder autorizar el pago.</p>
                </div>
            </div>

            <div class="monthly-timeline-step">
                <div class="monthly-timeline-rail">
                    <span class="monthly-timeline-icon" [class.is-done]="stepState(p, 3) === 'done'" [class.is-current]="stepState(p, 3) === 'current'">
                        <i class="ti ti-check" *ngIf="stepState(p, 3) === 'done'"></i>
                        <i class="ti ti-alert-circle" *ngIf="stepState(p, 3) === 'current'"></i>
                        <span *ngIf="stepState(p, 3) === 'pending'">3</span>
                    </span>
                </div>
                <div class="monthly-timeline-body">
                    <p class="monthly-timeline-title">Pago</p>
                    <p class="monthly-timeline-sub" *ngIf="p.status < 2">Pendiente de autorización</p>
                    <p class="monthly-timeline-sub" *ngIf="p.status === 2">Pendiente de registro de pago</p>
                    <p class="monthly-timeline-sub" *ngIf="p.status >= 3">Pagado el {{ formatDateTime(p.paid_at) }}</p>
                    <a *ngIf="p.status >= 3 && p.payment_proof_url" [href]="p.payment_proof_url" target="_blank" class="monthly-timeline-link">Ver comprobante</a>
                    <label class="monthly-timeline-link monthly-invoice-upload monthly-detail-btn" *ngIf="p.status === 2 && !actionLoading">
                        Adjuntar comprobante y registrar pago
                        <input type="file" accept=".pdf,.jpg,.jpeg,.png" (change)="onPaymentProofSelected($event)" hidden>
                    </label>
                    <span class="monthly-timeline-link" *ngIf="p.status === 2 && actionLoading">Subiendo…</span>
                </div>
            </div>
        </div>

        <div class="monthly-detail-due">
            <span>Vencimiento</span>
            <span class="monthly-detail-due-value"><i class="ti ti-calendar"></i> {{ formatDate(p.due_date) }}</span>
        </div>

        <a class="monthly-detail-provider" [routerLink]="['/provider/view', p.provider_id]" [queryParams]="{ name: p.provider_name }">
            <div class="monthly-card-avatar" [style.background]="p.avatarBg" [style.color]="p.avatarColor">{{ p.avatarInitial }}</div>
            <div class="monthly-detail-provider-body">
                <span class="monthly-timeline-sub">Proveedor</span>
                <p class="monthly-detail-provider-name">{{ p.provider_name }}</p>
            </div>
            <i class="ti ti-chevron-right"></i>
        </a>

        <h6 class="monthly-detail-subtitle">Datos bancarios</h6>
        <div class="monthly-detail-bank">
            <div>
                <span class="monthly-timeline-sub">Banco</span>
                <p class="monthly-detail-bank-value">{{ p.provider.bank_name || '—' }}</p>
            </div>
            <div>
                <span class="monthly-timeline-sub">Beneficiario</span>
                <p class="monthly-detail-bank-value">{{ p.provider.beneficiary_name || '—' }}</p>
            </div>
            <div>
                <span class="monthly-timeline-sub">Cuenta</span>
                <p class="monthly-detail-bank-value">{{ p.provider.account_number || '—' }}</p>
            </div>
            <div>
                <span class="monthly-timeline-sub">CLABE</span>
                <p class="monthly-detail-bank-value">{{ p.provider.clabe || '—' }}</p>
            </div>
            <div>
                <span class="monthly-timeline-sub">Tipo de cuenta</span>
                <p class="monthly-detail-bank-value">{{ p.provider.account_type || '—' }}</p>
            </div>
        </div>
    </ng-container>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
